"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurApproach() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const steps = [{
    number: 1,
    label: "Discovery"
  }, {
    number: 2,
    label: "Analysis"
  }, {
    number: 3,
    label: "Strategy"
  }, {
    number: 4,
    label: "Implementation"
  }];
  const textBlocks = [{
    title: "Customized Solutions",
    description: "We tailor our consulting approach to your unique business challenges, ensuring practical and actionable strategies that drive sustainable growth."
  }, {
    title: "Proven Expertise",
    description: "With deep experience in operational guidance and financial management, we deliver insights that strengthen your business performance."
  }, {
    title: "Partnership Focus",
    description: "We work alongside you as trusted advisors, committed to your success through every phase of your business journey."
  }];
  return <section ref={containerRef} className="relative bg-[hsl(210,8%,20%)] text-[hsl(0,0%,100%)] py-24 px-6 md:px-12 lg:px-24" style={{
    minHeight: "30vh"
  }}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-semibold mb-16 text-center font-display">
          Our Approach
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {}
          <div className="flex flex-col items-center lg:items-start space-y-12">
            {steps.map((step, i) => <div key={step.number} data-index={i} className="flex items-center space-x-6 group" style={{
            opacity: containerVisible ? 1 : 0,
            transform: containerVisible ? "translateX(0)" : "translateX(-2rem)",
            transition: `opacity 300ms ease-out ${i * 100}ms, transform 300ms ease-out ${i * 100}ms`
          }}>
                <div className="flex items-center justify-center w-16 h-16 rounded-full bg-[hsl(210,80%,45%)] text-white font-bold text-2xl shadow-[0_4px_16px_rgba(0,0,0,0.12)] transition-all duration-300 group-hover:shadow-[0_0_24px_rgba(59,130,246,0.6)] group-hover:scale-110" aria-label={`Step ${step.number}`}>
                  {step.number}
                </div>
                <span className="text-xl font-medium">{step.label}</span>
              </div>)}
          </div>

          {}
          <div className="space-y-10">
            {textBlocks.map((block, i) => <div key={i} data-index={i} className="p-6 rounded-lg bg-[hsl(210,8%,25%)] shadow-[0_2px_8px_rgba(0,0,0,0.04),0_1px_3px_rgba(0,0,0,0.08)]" style={{
            opacity: containerVisible ? 1 : 0,
            transform: containerVisible ? "translateY(0)" : "translateY(1.25rem)",
            transition: `opacity 300ms ease-out ${(i + 1) * 150}ms, transform 300ms ease-out ${(i + 1) * 150}ms`
          }}>
                <h3 className="text-2xl font-semibold mb-3 text-[hsl(170,70%,45%)]">
                  {block.title}
                </h3>
                <p className="text-base leading-relaxed text-[hsl(0,0%,90%)]">
                  {block.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}